const locale = require('./quoteSelectionModal.i18n.json');

/*@ngInject*/
const QuoteSelectionModalController = function ($rootScope, $scope, $q, formatUtil, coreMediator, options, coreConstant, quoteActionsMediator, breadcrumbsMediator, submissionConstant, quoteStatus) {
    $scope.i18n = locale;

    $scope.viewModel = {
        title: _.get($scope.i18n, options.transition),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: _.get($scope.i18n, options.transition),
        quoteSummaries: [],
        isLoading: true,
        allSelected: true
    };

    function onInit() {
        _.each(options.quoteSummaries, (quoteSummary) => {
            let lastBreadCrumbCompleted = null;
            _.each(quoteSummary.breadcrumb, (breadcrumb) => {
                if ($scope.isItemCompleted(breadcrumb) || $scope.isItemInProgress(breadcrumb)) {
                    if (breadcrumb.translateName) {
                        breadcrumb.name = _.get($scope.i18n, breadcrumb.name);
                        breadcrumb.stepCssSelector = formatUtil.formatAsSelector(breadcrumb.name);
                    }
                    if (quoteSummary.status === quoteStatus.VALID_RATING && breadcrumb.name==='Rate') {
                        breadcrumb.breadCrumbStatus = submissionConstant.breadcrumbsStatus.COMPLETE;
                    }
                    lastBreadCrumbCompleted = breadcrumb;
                }
            });
            quoteSummary.breadcrumb = lastBreadCrumbCompleted;
        });
        $scope.viewModel.quoteSummaries = options.quoteSummaries;
    }

    $scope.isItemCompleted = (breadcrumb) => {
        return breadcrumb.breadCrumbStatus === submissionConstant.breadcrumbsStatus.COMPLETE && !breadcrumb.earlyEnd;
    };

    $scope.isItemInProgress = (breadcrumb) => {
        return breadcrumb.breadCrumbStatus === submissionConstant.breadcrumbsStatus.IN_PROGRESS;
    };

    $scope.isItemEarlyEnd = (breadcrumb) => {
        return breadcrumb.earlyEnd && breadcrumb.breadCrumbStatus !== submissionConstant.breadcrumbsStatus.IN_PROGRESS;
    };

    $scope.onAllCheckboxClick = ($event) => {
        const selected = $event.target.checked;
        _.each($scope.viewModel.quoteSummaries, (quoteSummary) => {
            if (quoteSummary.actionEnabled) {
                quoteSummary.isSelected = selected;
            }
        });
    };

    $scope.onCheckboxClick = () => {
        let areAllSelected = true;
        _.each($scope.viewModel.quoteSummaries, (quoteSummary) => {
            if(quoteSummary.actionEnabled && !quoteSummary.isSelected){
                areAllSelected = false;
            }
        });
        $scope.viewModel.allSelected = areAllSelected;
    };

    $scope.onConfirm = () => {
        const selectedQuoteSummaries = _.filter($scope.viewModel.quoteSummaries, (quoteSummary) => {
                return quoteSummary.isSelected;
            }),
            selectedQuoteIds = _.map(selectedQuoteSummaries, _.property('id'));
        $scope.$close({
            quoteIds: selectedQuoteIds
        });
    };

    $scope.onCancel = () => {
        $scope.$dismiss();
    };

    $scope.canEnableConfirmButton = () => {
        let isQuoteSummarySelected = false;
        _.each($scope.viewModel.quoteSummaries, (quoteSummary) => {
            if (quoteSummary.isSelected) {
                isQuoteSummarySelected = true;
            }
        });
        return isQuoteSummarySelected;
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, () => {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    onInit();
};

angular.module('gw-um-submission')
    .controller('quoteSelectionModalController', QuoteSelectionModalController);
